function y(e) {
  const t = document.querySelectorAll(
    "body > *:not(script):not(noscript)"
  ), s = [];
  if (t.length === 0)
    throw new Error(
      `[directive:${e}] no children of body have been found`
    );
  for (let o = 0; o < t.length; o++)
    getComputedStyle(t[o]).position === "relative" && s.push(t[o]);
  if (s.length === 0)
    throw new Error(
      `[directive:${e}] no valid children of body with relative position have been found`
    );
  return s.length > 1 && console.warn(
    `[directive:${e}] serveral elements with position relative have been found. The directive will use the first one to place the html element.`
  ), s[0];
}
const a = 8, c = 20, L = [];
let l, g = !1;
const w = (e, t, s) => {
  if (!t)
    return;
  l = document.createElement("div");
  const o = y("tooltip");
  l.classList.add("TooltipD"), l.innerHTML = t, o.appendChild(l), g = !0, $(s, e) ? (b(s, e, l), R(e, l, s)) : x(e, l);
}, h = () => {
  l && (l.remove(), g = !1);
}, m = (e) => {
  const t = e.getAttribute("data-tootip-position");
  return t ? t.split(" ") : [];
}, $ = (e, t) => {
  const s = m(t);
  return e.top || e.bottom || e.left || e.right || e.side || e.center || s.length > 0;
}, b = (e, t, s) => {
  const o = "TooltipD--", i = m(t), d = i.includes("bottom"), f = i.includes("left"), r = i.includes("right"), p = i.includes("side");
  (e.bottom || d) && s.classList.add(`${o}bottom`), (e.left || f) && s.classList.add(`${o}left`), (e.right || r) && s.classList.add(`${o}right`), e.side && (s.classList.add(`${o}side`), !e.left && !e.right && s.classList.add(`${o}right`)), p && (s.classList.add(`${o}side`), !f && !r && s.classList.add(`${o}right`));
}, x = (e, t) => {
  const s = e.getBoundingClientRect();
  let o = 0;
  const i = t.offsetWidth, d = s.top - t.offsetHeight - a;
  if (t.style.top = `${d}px`, d < 40) {
    t.classList.add("TooltipD--bottom");
    const u = s.top + s.height + a;
    t.style.top = `${u}px`;
  }
  const f = s.left + s.width / 2 - t.offsetWidth / 2;
  t.style.left = `${f}px`;
  const r = f - t.offsetWidth / 2 < c, p = s.left + t.offsetWidth / 2 + s.width / 2 > window.innerWidth - 17 - c;
  if (r)
    t.classList.add("TooltipD--left"), s.width / 2 < c && (o = s.width / 2 - c), t.style.left = `${s.left + o}px`;
  else if (p) {
    t.classList.add("TooltipD--right"), s.width / 2 < c && (o = c - s.width / 2);
    const u = s.left - i + s.width + o;
    t.style.left = `${u}px`;
  }
  t.style.opacity = "1";
}, R = (e, t, s) => {
  const o = e.getBoundingClientRect();
  L.forEach((n) => {
    l.classList.add(n);
  });
  let i = 0;
  T(s);
  const d = m(e), f = d.includes("bottom"), r = d.includes("left"), p = d.includes("right"), u = d.includes("side");
  setTimeout(() => {
    if (s.side || u) {
      const n = o.top + o.height / 2 - t.offsetHeight / 2;
      if (t.style.top = `${n}px`, s.left || r) {
        const v = o.left - t.offsetWidth - a;
        t.style.left = `${v}px`;
      } else {
        const v = o.left + o.width + a;
        t.style.left = `${v}px`;
      }
      t.style.opacity = "1";
      return;
    } else if (s.bottom || f) {
      const n = o.top + o.height + a;
      t.style.top = `${n}px`;
    } else {
      const n = o.top - t.offsetHeight - a;
      t.style.top = `${n}px`;
    }
    if (s.left || r)
      o.width / 2 < c && (i = o.width / 2 - c), t.style.left = `${o.left + i}px`;
    else if (s.right || p) {
      o.width / 2 < c && (i = c - o.width / 2);
      const n = o.left + o.width - t.offsetWidth + i;
      t.style.left = `${n}px`;
    } else {
      const n = o.left + o.width / 2 - t.offsetWidth / 2;
      t.style.left = `${n}px`;
    }
    t.style.opacity = "1";
  }, 1);
}, T = (e) => {
  e.bottom && e.top && console.warn(
    "[directive:tooltip] modifiers 'bottom' and 'top' are not compatible at the same time, please set only one of them"
  ), e.left && e.right && console.warn(
    "[directive:tooltip] modifiers 'left' and 'right' are not compatible at the same time, please set only one of them"
  ), e.side && e.center && console.warn(
    "[directive:tooltip] modifiers 'side' and 'center' are not compatible at the same time, please set only one of them"
  ), e.side && !e.center && !e.left && !e.right && console.warn(
    "[directive:tooltip] modifiers 'side' must set position as well 'right' or 'left' to work properly"
  );
}, W = {
  beforeMount(e, t) {
    e.addEventListener("mouseenter", (s) => {
      const o = e.getAttribute("tooltip");
      o ? w(e, o.trim(), t.modifiers) : w(e, t.value.trim(), t.modifiers);
    }), e.addEventListener("mouseleave", h), window.addEventListener("scroll", h);
  },
  unmounted(e, t) {
    h(), e.removeEventListener("mouseenter", (s) => {
      w(e, t.value.trim(), t.modifiers);
    }), e.removeEventListener("mouseleave", h), window.removeEventListener("scroll", h);
  },
  updated(e, t) {
    t.oldValue !== t.value && (e.setAttribute("tooltip", t.value), g && (h(), w(e, t.value.trim(), t.modifiers)));
  }
};
export {
  W as T,
  y as g
};
